import React, { FC } from 'react';

import { Box } from '@rbilabs/universal-components';

import { IServerOrder } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import LoadingAnimation from 'components/loading-animation';
import { ServiceMode } from 'generated/graphql-gateway';
import { useCartContext } from 'state/cart';
import { t } from 'state/intl/translations';

import GrandTotal from '../../your-cart/totals/grand-total';
import TipSelector from '../../your-cart/totals/tip-selector';
import { useTotalTipCalculations } from '../../your-cart/totals/use-total-tip-calculations';

import { TotalsContainer } from './styled';
import { TipLabel } from './tip-label';

const Tip = Box.withConfig({
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export interface ITotals {
  serverOrder: IServerOrder | null;
  rewardApplied?: boolean;
  serviceMode: ServiceMode | null;
  isDisabled: boolean;
  isLoading: boolean;
}

export const Totals: FC<React.PropsWithChildren<ITotals>> = ({
  serverOrder,
  serviceMode,
  isDisabled,
  isLoading,
}) => {
  const { tipAmount, shouldShowTipPercentage } = useCartContext();
  const {
    subTotalCents = 0,
    serverOrderTip,
    additionalDiscountAmount,
    cart,
    isDeliveryOrder,
  } = useTotalTipCalculations({ serverOrder });

  if (isLoading) {
    // if loading is true there may have been a pricing error
    // so we should not attempt to render values that depend
    // on the cart
    return <LoadingAnimation />;
  }

  return (
    <TotalsContainer accessible>
      <GrandTotal
        cart={cart}
        serverOrderTip={serverOrderTip}
        tipAmount={isDeliveryOrder ? tipAmount : 0}
      />
      {isDeliveryOrder && (
        <>
          <Tip testID="tip-amount">
            {t('tip')}
            <Currency amount={tipAmount} />
          </Tip>
          <TipLabel />
          <TipSelector
            subTotalCents={subTotalCents}
            otherDiscountAmount={additionalDiscountAmount}
            showTipPercentage={shouldShowTipPercentage(subTotalCents + additionalDiscountAmount)}
            isDisabled={isDisabled}
          />
        </>
      )}
    </TotalsContainer>
  );
};

export default Totals;
